import accordion from './accordion'
import tabs from './tabs'
import tracking from './tracking'
import carousel from './carousel'

accordion()
tabs()
tracking()
carousel()
